<template>
  <b-modal
    id="school-employee-away-modal"
    size="lg"
    ok-only
    title="Individual Away"
  >
    <EmployeeIndividualLeaveTable :leaves="aways" :is-busy="isBusy">
    </EmployeeIndividualLeaveTable>

    <div class="d-flex justify-content-end" v-if="aways.length">
      <b-pagination
        pills
        size="lg"
        class="pt-5"
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        @change="$emit('page-change', $event)"
      ></b-pagination>
    </div>
  </b-modal>
</template>

<script>
import EmployeeIndividualLeaveTable from "@/modules/company/components/attendance/common/table/EmployeeIndividualLeaveTable";

export default {
  name: "EmployeeIndividualAwayModal",
  components: { EmployeeIndividualLeaveTable },
  props: {
    aways: {
      type: Array,
      required: true,
    },
    isBusy: {
      required: true,
      type: Boolean,
    },
    pagination: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped></style>
